export const TRIAL_COMPONENTS_EXPERIENCES = {
	ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
	// The trial grace period is formally known as the "pre-dunning" period
	GRACE_PERIOD_BANNER_DISMISSED: 'trial-components:trialGracePeriodBannerDismissed',
	TRIAL_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial1DayFlag',
	TRIAL_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial3DayFlag',
	GRACE_PERIOD_0_DAY_FLAG_DISMISSED: 'trial-components:dismissedGracePeriod0DayFlag',
	GRACE_PERIOD_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedGracePeriod1DayFlag',
	GRACE_PERIOD_2_DAY_FLAG_DISMISSED: 'trial-components:dismissedGracePeriod2DayFlag',
	GRACE_PERIOD_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedGracePeriod3DayFlag',
	TRIAL_UNHANDLED_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrialUnhandledDayFlag',
} as const;

export const TrialComponentsOnboardingKeys = [
	...Object.values(TRIAL_COMPONENTS_EXPERIENCES),
] as const;
